const fields = [
  {
    dataIndex: 'name',
    key: 'name',
    title: '需求内容',
    scopedSlots: {
      customRender: 'TextAction',
    },
  },
  // {
  //   dataIndex: 'demandsTypeStr',
  //   key: 'demandsType',
  //   title: '需求类型'
  // },
  {
    dataIndex: 'auditStatusStr',
    key: 'auditStatusStr',
    scopedSlots: {
      customRender: 'color',
    },
    title: '状态',
  },
  {
    dataIndex: 'createTime',
    key: 'createTime',
    title: '创建时间',
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    scopedSlots: {
      customRender: 'action',
    },
  },
];

const formRow = [
  {
    span: 12,
    label: '需求名称',
    component: 'AInput',
    placeholder: '请输入需求名称',
    prop: 'name',
    allowClear: true,
  },
  {
    span: 8,
    label: '创建日期',
    component: 'ASelect',
    prop: 'searchValue',
    placeholder: '选择创建日期',
    allowClear: true,
    list: [
      { label: '全部日期', value: '0' },
      { label: '近一个月', value: '1' },
      { label: '近三个月', value: '2' },
      { label: '近半年', value: '3' },
      { label: '近一年', value: '4' },
    ],
  },
];

const slotOpt = [
  {
    slot: 'TextAction',
    component: 'TextAction',
    cb: 'toDetail',
  },
  {
    slot: 'action',
    component: 'Action',
    list: [],
  },
];

module.exports = {
  fields,
  slotOpt,
  formRow,
};
